<template>
  <div id="cat" v-cloak>
    <div class="vx-card mb-4">
      <div class="vx-card__body card-body">
        <div class="flex">
          <div class="w-full">
            <vs-button
              @click="showFilters = !showFilters"
              class="bg_purple float-right"
              ><div class="px-3">
                <feather-icon
                  icon="FilterIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Filter") }}
              </div>
            </vs-button>
          </div>
        </div>
        <div class="vx-row" v-if="showFilters">
          <div class="vx-col w-full">
            <div class="vx-row flex items-end">
              <div class="vx-col md:w-1/4 w-full my-1 mt-1">
                <vs-input
                  class="inputx"
                  v-model="gridSearchData.CustomerName"
                  @keyup.enter="submitFilter"
                  v-trim-space
                  :label="$t('PartyName')"
                  placeholder="نام و نام خانوادگی / نام شرکت"
                />
              </div>

              <div class="vx-col md:w-1/4 w-full my-1">
                <label class="vs-select--label datepicker-lb">{{
                  $t("FromDate")
                }}</label>
                <date-picker
                  v-model="gridSearchData.fromDate"
                  type="date"
                  format="jYYYY-jMM-jDD"
                  display-format="jYYYY-jMM-jDD"
                  class="date-picker"
                  :label="$t('FromDate')"
                  :clearable="true"
                />
              </div>
              <div class="vx-col md:w-1/4 w-full my-1">
                <label class="vs-select--label datepicker-lb">{{
                  $t("ToDate")
                }}</label>
                <date-picker
                  v-model="gridSearchData.toDate"
                  type="date"
                  format="jYYYY-jMM-jDD"
                  display-format="jYYYY-jMM-jDD"
                  class="date-picker"
                  :label="$t('ToDate')"
                  :clearable="true"
                />
              </div>
              <div class="vx-col w-full sm:w-2/2 pt-6">
                <div class="flex gap-4 justify-end">
                  <vs-button
                    type="filled"
                    color="#3ec9d6"
                    @click.prevent="resetForm"
                    >{{ $t("ResetFilter") }}</vs-button
                  >
                  <vs-button
                    shadow
                    @click.prevent="submitFilter()"
                    v-has-permission="permission"
                    >{{ $t("SubmitFilter") }}</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :pageSizeManual="pageSizeManual"
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('PartyName'), sort: 'PartyName' },
                { title: $t('SalePersonName') },
                { title: $t('SiteOrderNumber'), sort: 'SiteOrderNumber' },
                { title: $t('ContractName'), sort: 'ContractName' },
                { title: $t('PaymentStatus'), sort: 'PaymentStatus' },
                {
                  title: $t('TotalAmountForPayment') + $t('RialsParenthesis'),
                  name: 'TotalAmount',
                  total: 'SumOfTotalAmount',
                },
                { title: $t('OrderTime'), sort: 'OrderTime' },
                { title: $t('Description') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row, pagination }">
                <td style="width: 15%">
                  {{ row.basketCustomerInfo.name }}
                </td>
                <td style="width: 12%">
                  {{ row.salePersonInfo ? row.salePersonInfo.name : "----" }}
                </td>
                <td style="width: 10%">
                  {{ "APO-" + row.id }}
                </td>
                <td style="width: 18%">
                  {{ row.basketContractInfo.contractTitle }}
                </td>
                <td style="width: 10%">
                  <span
                    v-if="row.persianPaymentStatus == 'تایید شده'"
                    class="green"
                    >{{ $t("Confirmed") }}</span
                  >
                  <span
                    v-if="row.persianPaymentStatus == 'رد شده'"
                    class="red"
                    >{{ $t("Rejected") }}</span
                  >
                  <span v-if="row.persianPaymentStatus == '-'" class="red"
                    >-</span
                  >
                </td>
                <td style="width: 12%">
                  {{ Number(row.totalAmount).toLocaleString() }}
                </td>
                <td style="width: 15%">
                  {{ row.closeTime }}
                </td>
                <td style="width: 15%">
                  {{ row.description ? row.description : "-" }}
                </td>
                <td style="width: 5%">
                  <router-link
                    :to="{
                      path:
                        '/WebSiteBaskets/BasketDetails/' +
                        tabIndex +
                        '/' +
                        row.id,
                      query: {
                        numberRowsPerPage: pagination.pageSize,
                      },
                    }"
                  >
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="d-inline"
                      v-has-permission="permission"
                    ></vs-button>
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name: "basketManagement_WebSiteBaskets_ReviewQueue_Index",
  components: {
    DataGrid,
  },
  props: {
    tabIndex: { default: "" },
    numberRowsPerPage: {
      default: -1,
    },
  },
  data() {
    return {
      showFilters: false,
      permission: "GetClosedBasketById",
      pageSizeManual: 10,
      gridDataSource: { data: [] },
      gridSearchData: {
        basketFlowState: "1",
        basketState: "1",
        SalesType: "1",
      },
    };
  },
  mounted() {
    this.pageSizeManual = this.numberRowsPerPage ? this.numberRowsPerPage : -1;
    this.gridDataSource = {
      type: "app",
      service: "/Sales/api/BasketsQuery",
    };
    this.renderGrid();
  },
  methods: {
    renderGrid() {
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 200);
    },
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        basketFlowState: "1",
        basketState: "1",
        SalesType: "1",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>

<style scoped>
#reset-btn {
  background: #3ec9d6 !important;
}
</style>
